import React, { FC, useCallback } from "react";

import { FixedSizeList as List } from "react-window";
import { AutoSizer, Size } from "react-virtualized";
import { GoodsSearchRow } from "./row";
import { EmptyState } from "../../../../../../components/state/empty";
import { faList, faSearch } from "@fortawesome/free-solid-svg-icons";
import { UserGoodsControl } from "../../../../../../../domain/control/Goods";

export type GoodsSearchListProps = {
  items: UserGoodsControl[] | null;
  onClick: (good: UserGoodsControl, type: string) => void;
};

export type GoodsSearchListRowProps = {
  items: UserGoodsControl[];
  onClick: React.MouseEventHandler<HTMLDivElement>;
};

export const GoodsSearchListWindow: FC<GoodsSearchListProps> = ({
  items,
  onClick,
}) => {
  /* eslint-disable */
  const onRowClick = useCallback<React.MouseEventHandler<HTMLDivElement>>(
    (e) => {
      if (!items) return;
      const index = e.currentTarget.dataset.index;
      if (index) {
        onClick(items[index as unknown as number], "Goods");
      }
    },
    [items]
  );

  /* eslint-enable */

  return items === null ? (
    <EmptyState
      icon={faSearch}
      title={"Buscar Bien o Equipo"}
      message={"Ingrese un término de búsqueda."}
    />
  ) : items.length > 0 ? (
    //@ts-ignore
    <AutoSizer>
      {(props: Size) => (
        <List
          height={props.height}
          itemCount={items?.length || 0}
          itemSize={200}
          width={props.width}
          itemData={{
            items,
            onClick: onRowClick,
          }}
        >
          {GoodsSearchRow}
        </List>
      )}
    </AutoSizer>
  ) : (
    <EmptyState
      icon={faList}
      title={"Sin resultados"}
      message={`No hay bienes o equipos que coincidan con la búsqueda.`}
    />
  );
};
